<template>
    <card :borderSize="0" background="warning-05" class="b-0 compare-sheet p-6">
        <article>
            <div class="flex-row mb-4 flex-bottom">
                <SaasIcon width="35" height="24" icon="sellsyCloud" />
                <span class="capitalize fs-5 ml-2"
                    >Sellsy {{ $filters.lowerCase(previousCurrentPlanLabel) }}</span
                >
                <div class="flex-item-right fs-3">
                    <span class="bold">{{ labelPlan }}</span>
                </div>
            </div>
            <ul class="ov-auto mb-0 cart-recap-products">
                <li
                    v-for="product in previousProductsWithLicences"
                    :key="product.code"
                    :class="{
                        'mb-to-free-licences':
                            freeLicencesByProduct(product.id) &&
                            !previousFreeLicencesByProduct(product.id),
                    }"
                    class="mb-2 flex-row"
                >
                    <div>
                        <p class="gray-80 mb-1 mt-0 fs-3">
                            {{
                                $l10n.n__(
                                    '%(total)s licence %(productsName)s',
                                    '%(total)s licences %(productsName)s',
                                    previousProducts[product.id].quantity,
                                    {
                                        total: previousProducts[product.id].quantity,
                                        productsName: product.title,
                                    },
                                )
                            }}
                        </p>
                        <span v-if="previousFreeLicencesByProduct(product.id)" class="gray-80">
                            {{
                                $l10n.n__(
                                    'Dont %s offerte',
                                    'Dont %s offertes',
                                    previousFreeLicencesByProduct(product.id),
                                    previousFreeLicencesByProduct(product.id),
                                )
                            }}
                        </span>
                    </div>
                    <template v-if="previousProducts[product.id].total">
                        <p
                            v-if="previousFreeLicencesByProduct(product.id)"
                            class="flex-item-right my-0"
                        >
                            <span class="strike gray-80">
                                {{
                                    $filters.numberFormatToFloatWithOptions(
                                        previousProducts[product.id].total.monthly.total_amount,
                                        numformat,
                                        true,
                                    )
                                }}
                            </span>
                            <span class="success-50 fs-3 pl-2 semibold">
                                {{
                                    $filters.numberFormatToFloatWithOptions(
                                        previousProducts[product.id].total.monthly
                                            .total_amount_discounted,
                                        numformat,
                                        true,
                                    )
                                }}
                                {{ $l10n.__('/mois') }}
                            </span>
                        </p>
                        <p v-else class="flex-item-right my-0 fs-3 semibold gray-80">
                            {{
                                $filters.numberFormatToFloatWithOptions(
                                    previousProducts[product.id].total.monthly
                                        .total_amount_discounted,
                                    numformat,
                                    true,
                                )
                            }}
                            {{ $l10n.__('/mois') }}
                        </p>
                    </template>
                </li>
                <li
                    v-for="product in previousPacksWithLicences"
                    :key="product.code"
                    class="mb-2 flex-row"
                >
                    <div>
                        <p class="gray-80 mb-1 mt-0 fs-3">
                            {{
                                $l10n.__('Module %(productsName)s', { productsName: product.title })
                            }}
                        </p>
                    </div>
                    <template v-if="previousProducts[product.id].total">
                        <!-- Discount detail -->
                        <p
                            v-if="
                                previousProducts[product.id].total.monthly.total_amount_discounted <
                                previousProducts[product.id].total.monthly.total_amount
                            "
                            class="flex-item-right my-0 semibold"
                        >
                            <span class="strike gray-80">
                                {{
                                    $filters.numberFormatToFloatWithOptions(
                                        previousProducts[product.id].total.monthly.total_amount,
                                        numformat,
                                        true,
                                    )
                                }}
                            </span>
                            <span class="success-50 fs-3 pl-2">
                                <template
                                    v-if="
                                        previousProducts[product.id].total.monthly
                                            .total_amount_discounted !== 0
                                    "
                                >
                                    {{
                                        $filters.numberFormatToFloatWithOptions(
                                            previousProducts[product.id].total.monthly
                                                .total_amount_discounted,
                                            numformat,
                                            true,
                                        )
                                    }}
                                    {{ $l10n.__('/mois') }}
                                </template>
                                <template v-else>{{ $l10n.__('Offert') }}</template>
                            </span>
                        </p>
                        <!-- Base price -->
                        <p v-else class="flex-item-right my-0 fs-3 semibold gray-80">
                            {{
                                $filters.numberFormatToFloatWithOptions(
                                    previousProducts[product.id].total.monthly
                                        .total_amount_discounted,
                                    numformat,
                                    true,
                                )
                            }}
                            {{ $l10n.__('/mois') }}
                        </p>
                    </template>
                </li>
            </ul>
        </article>
        <span class="separator my-3 block"></span>
        <article class="flex-row jc-space">
            <div class="flex-column fs-3 cart-recap-total-label">
                <span class="mb-1">{{ $l10n.__('Total HT avant remise') }}</span>
                <span class="mb-3 bold fs-2 flex-row ai-center"
                    >{{ $l10n.__('Variation') }}
                    <SaasIcon
                        width="6"
                        height="12"
                        class="ml-1"
                        :icon="getArrowOrientation(variousTotalYearly.total_amount)"
                    />
                </span>

                <span class="mb-1">{{ $l10n.__('Remise') }}</span>
                <span class="mb-3 bold fs-2 flex-row ai-center"
                    >{{ $l10n.__('Variation') }}
                    <SaasIcon
                        width="6"
                        height="12"
                        class="ml-1"
                        :icon="getArrowOrientation(variousTotalYearly.total_amount_discount)"
                    />
                </span>

                <span class="mb-1">{{ $l10n.__('Total HT') }}</span>
                <span class="mb-3 bold fs-2 flex-row ai-center"
                    >{{ $l10n.__('Variation') }}
                    <SaasIcon
                        width="6"
                        height="12"
                        class="ml-1"
                        :icon="getArrowOrientation(variousTotalYearly.total_amount_discounted)"
                    />
                </span>

                <span v-if="previousTaxRate && previousTaxRate !== 0" class="mb-3"
                    >{{ $l10n.__('TVA') }} {{ previousTaxRate }}%</span
                >
            </div>
            <div class="flex-column aright fs-3">
                <span class="mb-1"
                    >{{
                        $filters.numberFormatToFloatWithOptions(
                            previousTotalYearly.total_amount,
                            numformat,
                            true,
                        )
                    }}
                    {{ $l10n.__('/an') }}</span
                >
                <span class="mb-3 bold fs-2"
                    >{{
                        $filters.numberFormatToFloatWithOptions(
                            variousTotalYearly.total_amount,
                            numformat,
                            true,
                        )
                    }}
                    {{ $l10n.__('/an') }}</span
                >

                <span class="mb-1"
                    >{{
                        $filters.numberFormatToFloatWithOptions(
                            previousTotalYearly.total_amount_discount,
                            numformat,
                            true,
                        )
                    }}
                    {{ $l10n.__('/an') }}</span
                >
                <span class="mb-3 bold fs-2"
                    >{{
                        $filters.numberFormatToFloatWithOptions(
                            variousTotalYearly.total_amount_discount,
                            numformat,
                            true,
                        )
                    }}
                    {{ $l10n.__('/an') }}</span
                >

                <span class="mb-1"
                    >{{
                        $filters.numberFormatToFloatWithOptions(
                            previousTotalYearly.total_amount_discounted,
                            numformat,
                            true,
                        )
                    }}
                    {{ $l10n.__('/an') }}</span
                >
                <span class="mb-3 bold fs-2"
                    >{{
                        $filters.numberFormatToFloatWithOptions(
                            variousTotalYearly.total_amount_discounted,
                            numformat,
                            true,
                        )
                    }}
                    {{ $l10n.__('/an') }}</span
                >

                <span v-if="previousTaxRate && previousTaxRate !== 0" class="mb-3"
                    >{{
                        $filters.numberFormatToFloatWithOptions(
                            previousTotalYearly.total_amount_vat,
                            numformat,
                            true,
                        )
                    }}
                </span>
            </div>
            <div class="flex-column aright fs-3">
                <span class="mb-1"
                    >{{
                        $filters.numberFormatToFloatWithOptions(
                            previousTotalMonthly.total_amount,
                            numformat,
                            true,
                        )
                    }}
                    {{ $l10n.__('/mois') }}</span
                >
                <span class="mb-3 bold fs-2"
                    >{{
                        $filters.numberFormatToFloatWithOptions(
                            variousTotalMonthly.total_amount,
                            numformat,
                            true,
                        )
                    }}
                    {{ $l10n.__('/mois') }}</span
                >

                <span class="mb-1">
                    {{
                        $filters.numberFormatToFloatWithOptions(
                            previousTotalMonthly.total_amount_discount,
                            numformat,
                            true,
                        )
                    }}
                    {{ $l10n.__('/mois') }}</span
                >
                <span class="mb-3 bold fs-2">
                    {{
                        $filters.numberFormatToFloatWithOptions(
                            variousTotalMonthly.total_amount_discount,
                            numformat,
                            true,
                        )
                    }}
                    {{ $l10n.__('/mois') }}</span
                >

                <span class="mb-1">
                    {{
                        $filters.numberFormatToFloatWithOptions(
                            previousTotalMonthly.total_amount_discounted,
                            numformat,
                            true,
                        )
                    }}
                    {{ $l10n.__('/mois') }}</span
                >
                <span class="mb-3 bold fs-2">
                    {{
                        $filters.numberFormatToFloatWithOptions(
                            variousTotalMonthly.total_amount_discounted,
                            numformat,
                            true,
                        )
                    }}
                    {{ $l10n.__('/mois') }}</span
                >

                <span v-if="previousTaxRate && previousTaxRate !== 0" class="mb-3">
                    {{
                        $filters.numberFormatToFloatWithOptions(
                            previousTotalMonthly.total_amount_vat,
                            numformat,
                            true,
                        )
                    }}
                </span>
            </div>
        </article>

        <div class="separator my-3"></div>
        <article class="flex-row jc-space">
            <div class="cart-recap-total-label">
                <p class="fs-4 my-0 bold cart-recap-total-label">{{ $l10n.__('Total TTC') }}</p>
                <span class="mb-3 fs-2 flex-row ai-center"
                    >{{ $l10n.__('Variation') }}
                    <SaasIcon
                        width="6"
                        height="12"
                        class="ml-1"
                        :icon="getArrowOrientation(variousTotalYearly.total_amount_tax_included)"
                    />
                </span>
            </div>
            <div class="flex-column aright fs-3">
                <p class="fs-4 my-0 aright bold">
                    {{
                        $filters.numberFormatToFloatWithOptions(
                            previousTotalYearly.total_amount_tax_included,
                            numformat,
                            true,
                        )
                    }}
                    <span class="fs-2">{{ $l10n.__('/an') }}</span>
                </p>
                <span class="mb-3 fs-2">
                    {{
                        $filters.numberFormatToFloatWithOptions(
                            variousTotalYearly.total_amount_tax_included,
                            numformat,
                            true,
                        )
                    }}
                    {{ $l10n.__('/an') }}</span
                >
            </div>
            <div class="flex-column aright fs-3">
                <p class="fs-4 my-0 aright bold">
                    {{
                        $filters.numberFormatToFloatWithOptions(
                            previousTotalMonthly.total_amount_tax_included,
                            numformat,
                            true,
                        )
                    }}
                    <span class="fs-2">{{ $l10n.__('/mois') }} </span>
                </p>
                <span class="mb-3 fs-2">
                    {{
                        $filters.numberFormatToFloatWithOptions(
                            variousTotalMonthly.total_amount_tax_included,
                            numformat,
                            true,
                        )
                    }}
                    {{ $l10n.__('/mois') }}
                </span>
            </div>
        </article>
    </card>
</template>

<script>
import Card from 'vcomponents/Card.vue';
import SaasIcon from 'vcomponents/common/SaasIcon.vue';

export default {
    components: {
        Card,
        SaasIcon,
    },
    props: {
        store: {
            type: String,
            require: true,
        },
    },
    computed: {
        previousCurrentPlan() {
            return this.$store.getters[`${this.store}Cart/previousCurrentPlan`];
        },
        previousCurrentPlanLabel() {
            return this.$store.getters[`${this.store}Cart/previousCurrentPlanLabel`];
        },
        isPreviouslyYearly() {
            return this.$store.getters[`${this.store}Cart/isPreviouslyYearly`];
        },
        previousProductsWithLicences() {
            return this.$store.getters[`${this.store}Cart/previousProductsWithLicences`];
        },
        previousPacksWithLicences() {
            return this.$store.getters[`${this.store}Cart/previousPacksWithLicences`];
        },
        previousFreeLicencesByProduct() {
            return this.$store.getters[`${this.store}Cart/previousFreeLicencesByProduct`];
        },
        freeLicencesByProduct() {
            return this.$store.getters[`${this.store}Cart/freeLicencesByProduct`];
        },
        previousProducts() {
            return this.$store.getters[`${this.store}Cart/previousProducts`];
        },
        numformat() {
            return this.$store.getters[`${this.store}Cart/numformat`];
        },
        previousTaxRate() {
            return this.$store.getters[`${this.store}Cart/previousTaxRate`];
        },
        totalYearly() {
            return this.$store.getters[`${this.store}Cart/totalYearly`];
        },
        totalMonthly() {
            return this.$store.getters[`${this.store}Cart/totalMonthly`];
        },
        previousTotalYearly() {
            return this.$store.getters[`${this.store}Cart/previousTotalYearly`];
        },
        variousTotalYearly() {
            return this.$store.getters[`${this.store}Cart/variousTotalYearly`];
        },
        previousTotalMonthly() {
            return this.$store.getters[`${this.store}Cart/previousTotalMonthly`];
        },
        variousTotalMonthly() {
            return this.$store.getters[`${this.store}Cart/variousTotalMonthly`];
        },
        labelPlan() {
            return this.isPreviouslyYearly
                ? this.$l10n.__('Abonnement annuel')
                : this.$l10n.__('Abonnement mensuel');
        },
    },
    methods: {
        getArrowOrientation(amount) {
            switch (Math.sign(amount)) {
                case 1:
                    return 'carretUp';
                case 0:
                    return 'carretEqual';
                case -1:
                    return 'carretDown';
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.compare-sheet {
    width: 450px;
}
</style>
